import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SecurityBadges from '../components/SecurityBadges';
import { logger } from '../lib/utils';

const Success: React.FC = () => {
  // Clear stored form data on component mount to allow user to start a new inquiry
  // Note: We preserve tracking parameters (UTM, query strings) for analytics purposes
  useEffect(() => {
    try {
      // Clear form data from localStorage
      localStorage.removeItem('adressfinder_form_data');

      // Clear session ID from sessionStorage (tab-specific)
      sessionStorage.removeItem('funnel_session_id');

      // Clear order-specific data
      localStorage.removeItem('auftragsnummer');

      // DO NOT clear tracking parameters - these are preserved:
      // - adressfinder_url_query_string
      // - utm_source, utm_medium, utm_campaign, utm_content, utm_term
      // - first_visit_time
      // - initial_url_query_string

      logger.log('Successfully cleared form data and session (tracking parameters preserved)');
    } catch (error) {
      logger.error('Error clearing stored data:', error);
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-grow container mx-auto px-4 py-8 max-w-3xl">
        <div className="form-container fade-in">
          <h2 className="text-2xl md:text-3xl text-center font-bold text-prussian-blue mb-6">
            Vielen Dank für Ihren Adressauftrag!
          </h2>

          <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded mb-6">
            <p className="font-medium text-lg">Ihre Zahlung wurde erfolgreich verarbeitet.</p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 my-6">
            <p className="mb-4 text-base">
              <strong>Wir bedanken uns für das entgegengebrachte Vertrauen in unsere Plattform.</strong>
              <br /><br />
              Sie erhalten in Kürze eine Bestätigungs-E-Mail mit weiteren Informationen.
            </p>
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 my-6">
            <p className="mb-0 text-base">
              Sollten Sie noch weitere Fragen haben, wenden Sie sich gerne per E-Mail an{' '}
              <a href="mailto:info@adressfinder.org" className="text-prussian-blue font-medium">
                info@adressfinder.org
              </a>.
            </p>
          </div>

          <div className="mt-8 text-center">
            <Link
              to="/"
              className="inline-block bg-prussian-blue hover:bg-opacity-90 text-white font-medium py-3 px-8 rounded-md transition duration-200 text-base"
            >
              Zurück zur Startseite
            </Link>
          </div>
        </div>

        <div className="mt-8">
          <SecurityBadges />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Success;
